import styled from 'styled-components';
import { BasketOptionalPartsStyled } from '../BasketOptionalPartsStyled';
import { rem } from 'polished';

export const BasketOptionalPartsDetailsDS = styled(BasketOptionalPartsStyled)`
    border-color: ${({ theme }) => theme.colors.secondary};

    .titleWrapper {
        .title {
            font-size: ${({ theme }) => theme.fontSizes.h4};
        }
    }
    .parts {
        &__title {
            font-size: ${({ theme }) => theme.fontSizes.h4};
        }
        
        .part {
            border-radius: ${rem(8)};
            border-color: ${({ theme }) => theme.colors.grey16};
            &:hover,
            &:focus-visible,
            &.selected {
                background: none;
                border: 2px solid ${({ theme }) => theme.colors.secondary};
                padding: ${rem(23)};
            }

            &.selected {
                background: ${({ theme }) => theme.colors.grey4};
            }

            &__name {
                font-size: ${({ theme }) => theme.fontSizes.h5};
            }

            &__descriptionWrapper {
                &_link {
                    font-size: ${({ theme }) => theme.fontSizes.h5};
                  
                    &:hover,
                    &:focus-visible {
                        color: ${({ theme }) => theme.colors.primary};
                    }
                }
            }
        }
    }
`;